import { dataArraySieve } from "@smp/utils";

const AVAILABLE_TAGS = ["sticker_type", "color", "author"] as const;
const AVAILABLE_SORT = ["-created_at", "created_at"] as const;

export const queryParams = {
  deserialize: (
    string?: string,
  ): {
    search: string | undefined;
    tags: string[];
    sort: typeof AVAILABLE_SORT[number] | undefined;
  } => {
    string =
      string || typeof window !== "undefined" ? window.location.search : "";

    const params = string
      ? Object.fromEntries(new URLSearchParams(string))
      : {};

    return {
      search: params.search,
      tags: dataArraySieve(
        AVAILABLE_TAGS.map((tag) =>
          params[tag] ? `${tag}_${params[tag]}` : undefined,
        ),
      ),
      sort: AVAILABLE_SORT.includes(params.sort) ? params.sort : undefined,
    };
  },

  serialize: (search: string, tags: string[], sort?: string) => {
    const queryParams = tags.reduce<Record<string, string>>((acc, tag) => {
      const parts = tag.split("_");
      const value = parts.pop();
      const key = parts.join("_");

      if (key && value && AVAILABLE_TAGS.includes(key)) {
        acc[key] = value;
      }

      return acc;
    }, {});

    if (search) {
      queryParams.search = search;
    }

    if (sort && AVAILABLE_SORT.includes(sort)) {
      queryParams.sort = sort;
    }

    const query = new URLSearchParams(queryParams).toString();

    return query ? `?${query}` : "";
  },
};
